import IcAlert from 'assets/Icons/IcAlert';
import { Col } from 'components/Box/Col';
import Text from 'components/Text';
import styled from 'styled-components';
import IcUnavailableBooking from './IcUnavailableBooking';
import Box from 'components/Box';

const UnavailableBooking = () => {

  return (
    <Wrapper>
      <Container>
        <Col gap='2'>
          <Alert>
            <IcAlert />
            <Text style={{ fontWeight: 500 }} color='other_03'>
              Service Alert
            </Text>
          </Alert>
          <Col>
            <Text className='title'>Booking Link</Text>
            <Text className='title desc'>Unavailable</Text>
          </Col>
        </Col>
        <Description>
          <Text variant='H8' color='text_4'>
            The booking page you&apos;re looking for is currently unavailable. Please reach out to them directly.
          </Text>
        </Description>
        <Box display='flex' justifyContent='center'>
          <IcUnavailableBooking width='240' height='240' />
        </Box>
      </Container>
    </Wrapper>
  );
};

export default UnavailableBooking;

const Wrapper = styled.div`
  min-height: 100vh;
  background: #232f3e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Mona Sans';
`;

const Container = styled.div`
  max-width: 476px;
  margin: 0 auto;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  height: 100vh;
  padding: 24px;

  .back {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
  }
  .title {
    font-size: 40px;
    font-weight: 500;
    color: #1d2129;
  }

  .desc {
    color: #da072d;
    font-style: italic;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
  }
`;

const Alert = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  gap: 8px;
  background: #ffe5e7;
  border-radius: 100px;
  width: fit-content;
`;

const Description = styled.div`
  width: 100%;
  border-left: 4px solid #da072d;
  padding-left: 20px;
  box-sizing: border-box;
`;
